'use client';

import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ROLES } from 'types/roles';

import { Button } from '@components/Button';
import { TextGroup } from '@components/TextGroups';

import { getFullLoginUrl } from '@utils/helpers/pathHelpers';

import { ButtonGroup, LandingPageWrapper, NavigationContainer } from './styles/index';

interface LandingPageProps {
  locale: string;
}

export const LandingPage = ({ locale }: LandingPageProps) => {
  const schoolUrl = useMemo(() => getFullLoginUrl(ROLES.SCHOOL), []);
  const teacherUrl = useMemo(() => getFullLoginUrl(ROLES.TEACHER), []);

  const { t } = useTranslation('common');

  const roleButtons = [
    { role: ROLES.SCHOOL, url: schoolUrl, label: t('landingPage.school'), locale: locale },
    { role: ROLES.TEACHER, url: teacherUrl, label: t('landingPage.teacher'), locale: locale },
  ];

  return (
    <LandingPageWrapper>
      <TextGroup header={t('landingPage.title')} paragraph={t('landingPage.description')} />
      <NavigationContainer>
        <ButtonGroup>
          {roleButtons.map((button) => (
            <Button
              key={button.role}
              type="button"
              variant={'primary'}
              onClick={() => (window.location.href = button.url)}
              label={button.label}
            />
          ))}
        </ButtonGroup>
      </NavigationContainer>
    </LandingPageWrapper>
  );
};
